module.exports = __webpack_public_path__ + "static/media/mask5.3479aa94.JPG";